import React from 'react'
import { Grid, Button, Box, Typography } from '@the-platform-group/component-library'
import { ArrowForward as ArrowForwardIcon } from '@the-platform-group/component-library/Icons'
import { usePeopleMergeContext } from '../../contexts/PeopleMergeContext'
import ProfileSummary from './ProfileSummary'
import SearchInput from '../SearchInput'

const SearchInputs = ({ activeStep }) => {
  const { mergeData } = usePeopleMergeContext()
  const { selectedData, mergePreviewQuery, handleSearch } = mergeData
  const {
    sourceId,
    targetId,
    handleSourceIdChange,
    handleTargetIdChange,
    sourcePerson,
    targetPerson,
  } = selectedData
  const { isLoading, sourceError, targetError } = mergePreviewQuery

  const isMultiJobStep = activeStep === 1
  return (
    <Grid item container alignItems="flex-start" sx={{ p: 3, backgroundColor: 'grey.50' }}>
      {isMultiJobStep && (
        <Grid item xs={12} mb={3}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Primary profile details
          </Typography>
          <Typography variant="body2">
            The primary job may change based on the mapped data.
          </Typography>
        </Grid>
      )}
      <SearchInput
        label={!isMultiJobStep ? 'Platform UUID (source)' : 'Platform Profile'}
        value={sourceId}
        onChange={handleSourceIdChange}
        disabled={isLoading}
        error={sourceError}
        helperText={sourceError}
        isMultiJobStep={isMultiJobStep}
      >
        {sourcePerson && (
          <Grid item>
            <ProfileSummary person={sourcePerson} />
          </Grid>
        )}
      </SearchInput>

      <Grid item xs={2}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <ArrowForwardIcon
            color="primary"
            sx={{
              fontSize: 48,
            }}
          />
        </Box>
      </Grid>

      <SearchInput
        label={!isMultiJobStep ? 'FactSet UUID (target)' : 'FactSet Profile'}
        value={targetId}
        onChange={handleTargetIdChange}
        disabled={isLoading}
        error={targetError}
        helperText={targetError}
        isMultiJobStep={isMultiJobStep}
      >
        {targetPerson && (
          <Grid item>
            <ProfileSummary person={targetPerson} />
          </Grid>
        )}
      </SearchInput>

      <Grid item xs={12}>
        {activeStep === 0 && (
          <Box display="flex" justifyContent="center">
            <Button
              variant="outlined"
              color="primary"
              onClick={handleSearch}
              disabled={!sourceId || !targetId || isLoading}
              size="large"
            >
              {isLoading ? 'Loading...' : 'Search & Preview'}
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  )
}

export default SearchInputs
